import { useCallback } from 'react';
import type { NavigateOptions } from 'react-router/lib/hooks';
import { useNavigate } from 'react-router-dom';

import globalStore from 'src/stores/global-store';

const useSluggedNavigate = () => {
  const { queryParams } = globalStore;
  const navigate = useNavigate();

  const sluggedNavigate = useCallback(
    (path: string, options?: NavigateOptions) =>
      navigate(
        {
          pathname: path,
          search: queryParams,
        },
        options
      ),
    [navigate, queryParams]
  );

  return sluggedNavigate;
};

export default useSluggedNavigate;
